import { useInfiniteQuery } from '@tanstack/react-query';
import * as Mappers from '../mappers';
import * as Queries from '../queries';
import * as Types from '../types';

interface IProps {
  /** Filters for the list; pages are managed here. */
  params?: Omit<Types.IApi.List.Params, 'page'>;
  enabled?: boolean;
}

/**
 * Results page by page, for "load more" on phones. Keyed under
 * ['result', 'list'] so the invalidations that refresh the paged list
 * refresh this one too.
 */
const useInfiniteList = ({ params, enabled = true }: IProps = {}) => {
  const query = useInfiniteQuery({
    queryKey: ['result', 'list', 'infinite', JSON.stringify(params)],
    enabled,
    initialPageParam: 1,
    queryFn: ({ pageParam }): Promise<Types.IQuery.List> => Queries.List({ params: { ...params, page: pageParam } })[1](),
    getNextPageParam: (last) => (last.meta.page < last.meta.totalPages ? last.meta.page + 1 : undefined),
  });

  const pages = query.data?.pages ?? [];
  return {
    ...query,
    items: pages.flatMap((page) => page.items),
    // The total comes with every page; the first one is enough.
    meta: pages[0]?.meta ?? Mappers.Meta(),
  };
};

export default useInfiniteList;
